// this file is generated by update_shopify_store_data.py at 2026-11-03 20:17:22.923765
var courses = [
    {
        "course_id": "51EFE31E-8F11-F111-99A8-005056A7327D",
        "course_version": 7,
        "name": "Clarify Your Brand Declaration",
        "course_type": 1,
        "author_information": "Mary E. Maloney",
        "description": "Clarify Your Brand Declaration\u2122 is a self-paced, six-module online course designed to help individuals gain clarity, confidence, and conviction about the path forward for their professional brand. The program includes approximately two hours of instructional video content, engaging exercises and worksheets, and a step-by-step roadmap that leverages AI to support the creation of a clear, three-part framework: purpose, why, and how.\r\n\r\nThe modules provide a strong foundation for articulating expertise and defining one\u2019s \u201cwhy,\u201d enabling participants to move forward with confidence in any direction in their career or life\u2014even when the path feels uncertain. This course is an essential resource for leaders navigating change.",
        "learning_objectives_html": "<p>Upon completion of this online activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>\r\n    Clearly express what makes their leadership unique, moving beyond credentials to communicate their purpose, inherent strengths, and operating values with precision and confidence.\r\n    </li>\r\n    <li>\r\n    Use their Brand Declaration as a decision-making filter, enabling them to evaluate opportunities and navigate high-stakes environments, seasons of change, and organizational complexity with greater clarity and alignment.\r\n    </li>\r\n    <li>\r\n    Codify their non-negotiable performance standards (&ldquo;hows&rdquo;) that represent them at their best and serve as the foundation for consistent, values-aligned action.\r\n    </li>\r\n    <li>\r\n    Synthesize their impact into a concise, compelling leadership narrative that resonates with stakeholders, strengthening influence and executive presence.\r\n    </li>\r\n    <li>\r\n    Protect their energy drivers and intentionally amplify their impact by recognizing what depletes and what fuels them.\r\n    </li>\r\n</ul>",
        "course_outline_html": "<strong>1.0 Program Introduction</strong>\r\n<br />\r\n<em>Poll: What&rsquo;s the WHY that drives what you do?</em>\r\n<br />\r\n<br />\r\n<strong>2.0 Energy &amp; Focus Foundations</strong>\r\n<ul>\r\n    <li>Resource 1 &ndash; HBR Article: Manage Your Energy, Not Your Time</li>\r\n    <li>Resource 2 &ndash; Atomic Habits: An Easy &amp; Proven Way to Build Good Habits and Break Bad Ones</li>\r\n    <li>Resource 3 &ndash; The Productivity Guide: Time Management Strategies That Work</li>\r\n</ul>\r\n<strong>2.1 &ldquo;More of This Please&rdquo; Exercise</strong><br />\r\nIdentify where your current energy is being spent and whether it is aligned with your goals and brand.\r\n<ul>\r\n    <li>Resource &ndash; Downloadable worksheet</li>\r\n</ul>\r\n<strong>2.2 &ldquo;Your Energy Song&rdquo; (Brandthem&reg;)</strong>\r\n<ul>\r\n    <li>Resource &ndash; Article: Why Is Music Good for the Brain?</li>\r\n</ul>\r\n<strong>2.3 Wrap-Up &amp; Next Steps</strong>\r\n<br />\r\n<br />\r\n<strong>3.0 The Impact of Purpose &amp; Brand Stories</strong>\r\n<strong>3.1 Discern Your 2&ndash;3 Word Purpose</strong>\r\n<ul>\r\n    <li>Resource &ndash; Downloadable worksheet</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7E6F5EAC-D8D6-F111-99B6-005056A7C0C7",
                "course_category_name": "Revealing Genius",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Effective Communication",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C01FDB4F-F53E-E711-B09D-005056B10493",
                "course_category_name": "Leadership & Workforce Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Interpersonal Relationships",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6B6770BB-8D11-F111-99A8-005056A7327D",
                "course_category_name": "Revealing Genius",
                "is_system_course_category": null
            },
            {
                "course_category_id": "463623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Personal Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "84B73F7B-8E11-F111-99A8-005056A7327D",
                "course_category_name": "Revealing Genius",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EED39483-D8D6-F111-99B6-005056A7C0C7",
                "course_category_name": "Revealing Genius",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                "course_category_name": "Workforce Culture",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EA93A9F5-8D11-F111-99A8-005056A7327D",
                "course_category_name": "Revealing Genius",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];